export default __webpack_public_path__ + "static/media/blackX.3c90b6c2.svg";